import * as globalBehaviors from '@cian/global-behaviors/browser';
import * as httpApi from '@cian/http-api/browser';
import * as telemetry from '@cian/telemetry/browser';
import * as web from '@cian/web/browser';
import { setupAxiosInstance } from 'shared/api/axiosInstance';
import { initConfig } from '@cian/config/browser';
import { initLogger } from '@cian/logger/browser';

export function setupDependencies() {
  telemetry.setup();
  httpApi.setup({});
}

export function initDependencies() {
  const config = initConfig();
  const logger = initLogger();
  telemetry.init();
  httpApi.init();
  web.init();
  globalBehaviors.init();

  setupAxiosInstance(config, logger);
}
